import posthog from "posthog-js";

if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: "/ingest",
    ui_host: "https://us.posthog.com",
    defaults: "2026-01-30",
    capture_exceptions: true,
    debug: process.env.NODE_ENV === "development",
    // Session replay — sampled at 10% in production. Masks all text by
    // default (farmer soil data and customer names are sensitive);
    // specific allow-list attrs (data-ph-no-mask) can unmask non-PII
    // copy if needed in follow-up commits.
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "*",
      sampleRate: 0.1,
    },
  });
}
